export default "__VITE_ASSET__Bs_RMaGm__"